import axios from 'axios';
import { store } from '~redux_related/store';
import { LOGOUT } from '~redux_related/user/actions';

export const lawsAPI = function () {
    const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    const instance = axios.create(params);

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch({ type: LOGOUT });
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
export const lawsAPINoToken = function () {
    // const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            // Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    const instance = axios.create(params);

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch({ type: LOGOUT });
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
export const calendarAPI = function () {
    const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: 'https://dev.tracktrack.su/calendar_api',
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    const instance = axios.create(params);

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch({ type: LOGOUT });
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
export const lawsAPICalendar = function () {
    // const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.LAWS_API_URL,
        // baseURL: process.env.CALENDAR_LAWS_API_URL,
        headers: {
            // Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    const instance = axios.create(params);

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch({ type: LOGOUT });
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
export const lawsAPICalendarNoLogin = function () {
    // const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            // Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    const instance = axios.create(params);

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch({ type: LOGOUT });
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
export const PDFAPICalendar = function () {
    const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.CALENDAR_LAWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/pdf',
        },
    };
    return axios.create(params);
};

export const lawsAPIToken = function () {
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            // 'frontendkey': process.env.FRONTENDKEY,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};

export const lawsAPIMultipart = function () {
    const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'content-type': 'multipart/form-data',
        },
    };

    const instance = axios.create(params);

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch({ type: LOGOUT });
            }
            return Promise.reject(error);
        }
    );
    return instance;
    // return axios.create(params);
};

export const lawsAPILite = function () {
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};

export const mlFilesAPI = function () {
    const params = {
        baseURL: '',
        headers: {
            'Content-Type': 'text/plain',
        },
    };
    return axios.create(params);
};

export const PDFAPI = function () {
    const token = store.getState().user.lawsUser.token;
    const params = {
        baseURL: process.env.LAWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/pdf',
        },
    };
    return axios.create(params);
};



// WEBPACK FOOTER //
// ./src/api/laws.js